import { render, staticRenderFns } from "./FolioModal.vue?vue&type=template&id=595dd41e&scoped=true&"
import script from "./FolioModal.vue?vue&type=script&lang=js&"
export * from "./FolioModal.vue?vue&type=script&lang=js&"
import style0 from "./FolioModal.vue?vue&type=style&index=0&id=595dd41e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595dd41e",
  null
  
)

export default component.exports